// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckboxField_container__3NTt4","checkbox":"CheckboxField_checkbox__2pk8E"};